export const vertexShader = `
#define PI 3.14159265359

uniform float elapsedTime;
uniform float duration;
uniform float size;
uniform float scale;

attribute vec3 targetPosition;
attribute vec3 targetColor;

varying vec3 vColor;
varying vec3 vTargetColor;
varying float vProgress;

float sineInOut(float k) {
    if( k <= 0.0 ) {
        return 0.0;
    } else if( k >= 1.0 ) {
        return 1.0;
    } else {
        return -(cos(PI * k) - 1.0) / 2.0;
    }
}

void main() {
    
    vColor = color;
    vTargetColor = targetColor;

    //calculate time value
    float t = elapsedTime / duration;

    //calculate progress
    vProgress = sineInOut(t);

    //calculate new position
    vec3 delta = targetPosition - position;
    vec3 newPosition = position + delta * vProgress;

    vec4 mvPosition = modelViewMatrix * vec4(newPosition, 1.0);
    gl_PointSize = size * (scale / -mvPosition.z);
    gl_Position = projectionMatrix * mvPosition;
}
`;

export const fragmentShader = `
uniform sampler2D pointTexture;

varying vec3 vColor;
varying vec3 vTargetColor;
varying float vProgress;

void main() {

    //calculate color
    vec3 delta = vTargetColor - vColor;
    vec3 newColor = vColor + delta * vProgress;

    gl_FragColor = vec4(newColor, 1.0);
    gl_FragColor = gl_FragColor * texture2D(pointTexture, gl_PointCoord);
    //gl_FragColor = texture2D(pointTexture, gl_PointCoord);
}
`;